import axios from "axios";

const api = axios.create({
  baseURL: "https://geogas.letitechsl.com",
  headers: {
    "Content-Type": "application/json",
  },
});

// Automatically attach the Bearer token from localStorage on every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
